import { INPUT_TYPES, TEXT_AREA } from '@/app.constants';
import { checkHtmlInjection } from '@/utils/utility';
import { useCallback } from 'react';
import toast from '@/config/react-toast'

const useHtmlValidations = ({ 
  type,
  onChange
}: { 
  type: typeof INPUT_TYPES[keyof typeof INPUT_TYPES],
  onChange: (e: FocusEvent) => void
  }) => {

  const handleValueReset = ({e, onChange}: {e: FocusEvent, onChange: (e: FocusEvent) => void}): void => {
    const target = e.target as HTMLInputElement;
    target.value = '';
    if (onChange) {
      const syntheticOnChangeEvent = Object.assign(e, {
        type: 'change',
      }) as unknown as FocusEvent;
      onChange(syntheticOnChangeEvent);
    }

    toast(
      'HTML or markup content was found and removed. Please use plain text only.',
      { type: 'error' }
    );
  };

  const handleHtmlValidation = useCallback((e: FocusEvent):void  => {
    try {
      // Perform HTML validation for all input types EXCEPT password and textarea fields
      if (type !== INPUT_TYPES.PASSWORD && type !== TEXT_AREA) {

        const target = e.target as HTMLInputElement;
        const value = target.value;
        if(checkHtmlInjection(value)) {
          handleValueReset({ e, onChange });
          return;
        }

      }

    } catch (error) {
      console.error('Error while parsing input:', error);
    }
  }, [type]);

  return { handleHtmlValidation };
};

export default useHtmlValidations;